<template>
  <div class="search">
    <div class="search__content">
      <div class="search__items">
        <div class="search__items-left">
          <Treeselect
              class="select"
              v-model="SelectCategory"
              :disable-branch-nodes="true"
              :show-count="true"
              :options="searchData"
              placeholder="Выберите категорию"
              
            />
        </div>
        <div class="search__items-center">
          <input type="search" placeholder="Поиск объявлений..." />
        </div>
        <div class="search__items-right">
          <svg
            width="13"
            height="16"
            viewBox="0 0 13 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M6.5 9C7.512 9 8.33333 8.10397 8.33333 6.99997C8.33333 5.89597 7.512 4.99998 6.5 4.99998C5.488 4.99998 4.66667 5.89597 4.66667 6.99997C4.66667 8.10397 5.488 9 6.5 9Z"
              stroke="#1D1929"
              stroke-linecap="square"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12 6.99997C12 12 6.5 15 6.5 15C6.5 15 1 12 1 6.99997C1 3.68697 3.46308 1 6.5 1C9.53692 1 12 3.68697 12 6.99997Z"
              stroke="#1D1929"
              stroke-linecap="square"
            />
          </svg>
          <Treeselect
              class="select"
              v-model="SelectLocation"
              :disable-branch-nodes="true"
              :show-count="true"
              :options="locationData"
              placeholder="Выберите категорию"
              
            />
          <button @click="searchPage()">
            
            <svg
              width="21"
              height="21"
              viewBox="0 0 21 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M20.7099 19.2899L16.9999 15.6099C18.44 13.8143 19.1374 11.5352 18.9487 9.2412C18.76 6.94721 17.6996 4.81269 15.9854 3.27655C14.2713 1.74041 12.0337 0.919414 9.73283 0.982375C7.43194 1.04534 5.24263 1.98747 3.61505 3.61505C1.98747 5.24263 1.04534 7.43194 0.982375 9.73283C0.919414 12.0337 1.74041 14.2713 3.27655 15.9854C4.81269 17.6996 6.94721 18.76 9.2412 18.9487C11.5352 19.1374 13.8143 18.44 15.6099 16.9999L19.2899 20.6799C19.3829 20.7736 19.4935 20.848 19.6153 20.8988C19.7372 20.9496 19.8679 20.9757 19.9999 20.9757C20.1319 20.9757 20.2626 20.9496 20.3845 20.8988C20.5063 20.848 20.6169 20.7736 20.7099 20.6799C20.8901 20.4934 20.9909 20.2442 20.9909 19.9849C20.9909 19.7256 20.8901 19.4764 20.7099 19.2899ZM9.9999 16.9999C8.61544 16.9999 7.26206 16.5894 6.11091 15.8202C4.95977 15.051 4.06256 13.9578 3.53275 12.6787C3.00293 11.3996 2.86431 9.99214 3.13441 8.63427C3.4045 7.27641 4.07119 6.02912 5.05016 5.05016C6.02912 4.07119 7.27641 3.4045 8.63427 3.13441C9.99214 2.86431 11.3996 3.00293 12.6787 3.53275C13.9578 4.06256 15.051 4.95977 15.8202 6.11091C16.5894 7.26206 16.9999 8.61544 16.9999 9.9999C16.9999 11.8564 16.2624 13.6369 14.9497 14.9497C13.6369 16.2624 11.8564 16.9999 9.9999 16.9999Z"
                fill="black"
              />
            </svg>
          </button>
        </div>
      </div>
      
      <div v-if="$route.name === 'CategoryBySlug'" class="search__bottom">
        <div class="search__bottom-content">
          <div class="sInput">
            <div class="sInput__desc">
              <div class="sInput__desc-title">
                <span>Цена</span>
              </div>
              <!-- <div class="sInput__desc-txt">
                <span>Не важно</span>
              </div> -->
            </div>
            <div class="sInput__inputs">
              <div class="sInput__inputs-item">
                <span class="sInput__inputs-item-title">От</span>
                <input type="text" />
              </div>
              <div class="sInput__inputs-item">
                <span class="sInput__inputs-item-title">До</span>
                <input type="text" />
              </div>
            </div>
          </div>
          <div class="sCheckbox">
            <div class="sCheckbox__check">
              <input type="checkbox">
            </div>
            <div class="sCheckbox__title">
              <span>На обмен</span>
              
            </div>  
          </div>
          <div class="sCheckbox">
            <div class="sCheckbox__check">
              <input type="checkbox">
            </div>
            <div class="sCheckbox__title">
              <span>C фото</span>
            </div>  
          </div>
          <div class="sCheckbox">
            <div class="sCheckbox__check">
              <input type="checkbox">
            </div>
            <div class="sCheckbox__title">
              <span>Возможна доставка</span>
            </div>  
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import SelectComponent from "../SelectComponent.vue";
import Treeselect from "vue3-treeselect";
export default {
  components: { SelectComponent,Treeselect },
  data: () => ({
    SelectCategory: null,
    SelectLocation: null
  }),
  created() {
    this.FETCH_SEARCH_CATEGORY();
    this.FETCH_LOCATION();
  },
  mounted() {},
  computed: {
    ...mapGetters({
      searchData: "GET_SEARCH_CATEGORY",
      locationData: "GET_LOCATION",
    }),
    newSearch() {
      let title1 = this.searchData.map((item) => ({
        id: item.id,
        title: item.title,
      }));
      title1.unshift({ id: "", title: "Все категории" });
      return title1;
    },
    newLocation() {
      let title = this.locationData.map((item) => ({
        id: item.id,
        title: item.title,
      }));
      title.unshift({ id: "", title: "Весь Казахстан" });
      return title;
    },
  },
  methods: {
    ...mapActions(["FETCH_SEARCH_CATEGORY", "FETCH_LOCATION"]),
    selectOption(option) {
      this.selectedPayment = option;
    },
    selectOption2(option) {
      this.selectedPayment2 = option;
    },
    searchPage(){
      this.$router.push({name : 'CategoryBySlug', params: {
        slug: 'eeee'
      }})
    }
  },
  watch: {
    newSearch() {
      this.selectedPayment = this.newSearch[0];
    },
    newLocation() {
      this.selectedPayment2 = this.newLocation[0];
    },
  },
};
</script>

<style lang="scss">

</style>
